import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlyoutOpeningData, SessionDetails } from '../flyout-models';
import { Subscription } from 'rxjs';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-source',
  templateUrl: './flyout-source.component.html',
  styleUrls: ['./flyout-source.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutSourceComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private sessionDetails: SessionDetails;
  private sessionSubscription: Subscription;
  private _openingData: FlyoutOpeningData;

  public utmSource: string;
  public utmName: string;
  public utmMedium: string;
  public utmTime: string;
  public referer: string;
  public refererType: string;
  public source: string;
  public expandedTab: string;

  @Input()
  public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this._openingData = openingData;
    this.expandedTab = this._openingData.expandedTab;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutSourceComponent');
  }

  ngOnInit(): void {
    this.sessionSubscription = this.flyoutService.sessionDetailsBS.subscribe((sessionDetails: SessionDetails) => {
      this.sessionDetails = sessionDetails;
    });
    if (this.sessionDetails) {
      this.processSourceInfo();
    }
  }

  public processSourceInfo(): void {
    this.referer = this.getSocialMediaSiteFromDomain(this.sessionDetails.referrerDomain);
    if (this.sessionDetails.utm) {
      this.utmSource = this.sessionDetails.utm.source;
      this.utmName = this.sessionDetails.utm.campaignName;
      this.utmMedium = this.sessionDetails.utm.medium;
      this.utmTime = this.sessionDetails.utm.time;
    }
    this.refererType = this.sessionDetails.referrerType;
    if (!this.referer && !this.utmSource) {
      this.source = 'Direct';
    }
  }

  private getSocialMediaSiteFromDomain(url: string): string {
    if (url == null) return null;

    const linkedIn = ['lnkd.in', 'linkedin.'];
    const facebook = ['facebook.', 'l.facebook.com'];
    const pinterest = ['pinterest.'];
    const instagram = ['instagram.'];
    const twitter = ['t.co'];

    if (linkedIn.find((d) => d === url)) {
      return 'LinkedIn';
    }
    if (facebook.find((d) => d === url)) {
      return 'Facebook';
    }
    if (pinterest.find((d) => d === url)) {
      return 'Pinterest';
    }
    if (instagram.find((d) => d === url)) {
      return 'Instagram';
    }
    if (twitter.find((d) => d === url)) {
      return 'Twitter';
    }
    return url;
  }

  ngOnDestroy() {
    this.sessionSubscription.unsubscribe();
  }
}
